import { Y_AXIS_PADDING } from '../components/CycleChartPreview/constants';

const applyYAxisPadding = (value: number, base: { min: number; max: number }, direction: 'min' | 'max') => {
  if (direction === 'min') {
    if (value > base.min && value < base.max) {
      return value - Y_AXIS_PADDING;
    }

    return base.min - Y_AXIS_PADDING;
  }

  if (direction === 'max') {
    if (value > base.max) {
      return base.max + Y_AXIS_PADDING;
    }

    return value + Y_AXIS_PADDING;
  }
};

export default applyYAxisPadding;
